import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPill } from 'components/common/ns-pill/NsPill';

export const testID = 'EnergySavingFactTestId';

type EnergySavingFactProps = {
  fact: React.ReactNode;
};

export const EnergySavingFact = ({ fact }: EnergySavingFactProps) => {
  return (
    <NsColumn hockeypitch="2:1">
      <NsCard testId={testID}>
        <NsPill>Energy saving tip</NsPill>
        <p slot="content">
          <strong>{fact}</strong>
        </p>
      </NsCard>
    </NsColumn>
  );
};

export default EnergySavingFact;
